import gql from 'graphql-tag';

import taskFragment from './taskFragment';

export const tasksPageFragment = gql`
  fragment tasksPageFragment on TasksPage {
    dokkioClass
    total
    tasks {
      ...taskFragment
    }
  }
  ${taskFragment}
`;
export default tasksPageFragment;
